import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import type {RootState} from './store';
import {lmrEnrolment} from '../api/lmr.api';
//import axios from 'axios';

interface user {
  resultCode: string;
  message: string;
  result: boolean;
  cardNumber: string;
  firstName: string;
  lastName: string;
}

interface usersState {
  users: user;
  loading: boolean;
  error: string;
}

const initialData = {
  resultCode: '',
  message: '',
  result: false,
  cardNumber: '',
  firstName: '',
  lastName: '',
};
// Define the initial state using that type
const initialState: usersState = {
  users: initialData,
  loading: false,
  error: '',
};

export const enrolCustomer = createAsyncThunk(
  'users/fetchUsers',
  async (parameters: any, thunkApi) => {
    return lmrEnrolment(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const userContainerSlice = createSlice({
  name: 'users',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(enrolCustomer.pending, state => {
      state.loading = true;
    });
    builder.addCase(enrolCustomer.fulfilled, (state, action) => {
      state.loading = false;
      state.users = action.payload;
    });
    builder.addCase(enrolCustomer.rejected, (state, action) => {
      console.log('action====>', action);
      state.error = action.toString();

      state.loading = false;
    });
  },
});

//Other code such as selectors can use the imported `RootState` type
export const userData = (state: RootState): user => state.userReducer.users;
export const error = (state: RootState): string => state.userReducer.error;
export const loading = (state: RootState): boolean => state.userReducer.loading;

export default userContainerSlice.reducer;
